import { Injectable, inject } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root',
})
export class UiService {
  private readonly toastController = inject(ToastController);
  private readonly loadingCtrl = inject(LoadingController);
  private loading: HTMLIonLoadingElement | null = null;

  async showToast(
    message: string,
    color:
      | 'success'
      | 'danger'
      | 'warning'
      | 'primary'
      | 'secondary'
      | 'tertiary' = 'success',
    duration = 2000,
  ) {
    const toast = await this.toastController.create({
      message,
      color,
      duration,
      position: 'top',
      swipeGesture: 'vertical',
      icon: color === 'danger' ? 'close' : 'checkmark',
    });
    return toast.present();
  }

  async showLoading() {
    if (this.loading) return;
    this.loading = await this.loadingCtrl.create({
      cssClass: 'custom-loading',
      message: 'Cargando...',
    });
    await this.loading.present();
  }

  async dismissLoading() {
    if (this.loading) {
      await this.loading.dismiss();
      this.loading = null;
    }
  }
}
